export default __webpack_public_path__ + "static/media/Terms and conditions.6be7d71e.pdf";